<div class="static-wrapper">
  <div>
    <span>DATED: 25/09/2022</span>
    <br>
    <span class="center">INTRODUCTION</span>
    <br>
    <span>Welcome to the privacy policy of Curriculum Ltd (company number 12190456) of The Cleeves The Fooks,
            Horsley, Stroud, United Kingdom, GL6 0PA (referred to as “<span class="bold">we</span>”, “<span class="bold">us</span>”
            and “<span class="bold">our</span>” in this privacy policy).</span>
    <br><br>
    <span>We respect your privacy and are committed to protecting your personal data. This privacy policy will inform
            you as to how we look after your personal data when you visit our website (regardless of where you visit it
            from) and tell you about your privacy rights and how the law protects you.</span>
    <br><br>
    <span>The Glossary below explains the meanings of some of the terms used in this privacy policy.</span>
    <br><br><br>

    <span class="center">1. IMPORTANT INFORMATION AND WHO WE ARE</span>
    <span class="center">PURPOSE OF THIS PRIVACY POLICY</span>
    This privacy policy aims to give you information on how we collect and process your personal data through the
    purchase and use of our products and services and the use of this website, including any data you may provide
    through this website when you sign up to our newsletter.
    <br><br>
    The online learning services we offer are intended for high school aged students (not adults) and we therefore
    need to collect data relating to children. Whether you are under or over the age of 16 years, both you and your
    parent or guardian should read this privacy policy. We advise parents and guardians who permit their children to
    use online services to communicate with their children about their safety online.
    <br><br>
    It is important that you read this privacy policy together with any other privacy policy or fair processing
    policy we may provide on specific occasions when we are collecting or processing personal data about you so that
    you are fully aware of how and why we are using your data. This privacy policy supplements other notices and
    privacy policies and is not intended to override them.
    <br><br>

    <span class="center">CONTROLLER</span>
    We are the controller and responsible for the personal data we collect through the purchase and use of our
    products and services and the use of this website.
    <br><br>
    We have appointed a data protection officer (DPO) who is responsible for overseeing questions in relation to this
    privacy policy. If you have any questions about this privacy policy, including any requests to exercise your
    legal rights (as described below), please contact the DPO using the details set out below.
    <br><br>

    <span class="center">CONTACT</span>
    If you have any questions about this privacy policy or our privacy practices, please contact our DPO in the
    following ways:
    <br><br>
    By post: Curriculum Ltd, The Cleeves The Fooks, Horsley, Stroud, United Kingdom, GL6 0PA.
    <br><br>
    By email: <a href="mailto:contact@curriculum.com">contact@curriculum.com</a>.
    <br><br>

    <span class="center">COMPLAINTS</span>
    You have the right to make a complaint at any time to the Information Commissioner's Office (ICO), the UK
    supervisory authority for data protection issues at <a href="https://ico.org.uk/">www.ico.org.uk</a>. We would, however,
    appreciate the chance to deal with your concerns before you approach the ICO so please contact us in the first
    instance.
    <br><br>

    <span class="center">CHANGES TO THIS PRIVACY POLICY AND YOUR DUTY TO INFORM US OF CHANGES</span>
    We keep our privacy policy under regular review. This version was last updated on the date set out at the top of
    this privacy policy. We will notify you of any material changes by pop-up on this webpage. Historic versions can
    be obtained by contacting us.
    <br><br>
    It is important that the personal data we hold about you is accurate and current. Please keep us informed if your
    personal data changes during your relationship with us.
    <br><br>

    <span class="center">THIRD PARTY LINKS</span>
    This website may include links to third-party websites, plug-ins and applications. Clicking on those links or
    enabling those connections may allow third parties to collect or share data about you. We do not control these
    third-party websites and are not responsible for their privacy statements. When you leave our website, we
    encourage you to read the privacy policy of every website you visit.
    <br><br><br>

    <span class="center">2. THE DATA WE COLLECT ABOUT YOU</span>
    <span>Personal data, or personal information, means any information about an individual from which that person
            can be identified. It does not include data where the identity has been removed (anonymous data).</span>
    <br><br>
    <span>We may collect, use, store and transfer different types of personal data about you which we have grouped
            together as follows:</span>
    <br><br>
    &bull; Identity Data includes name, username or similar identifier, date of birth and gender.
    <br>
    &bull; Contact Data includes email address, address and telephone number.
    <br>
    &bull; Technical Data includes internet protocol (IP) address, your login data, browser type and version, time
    zone setting and location, browser plug-in types and versions, operating system and platform, and other
    technology on the devices you use to access this website.
    <br>
    &bull; Profile Data includes information about academic work, marks, progress reports, preferences, feedback and
    survey responses.
    <br>
    &bull; Usage Data includes information about how you use our website, products and services.
    <br>
    &bull; Marketing and Communications Data includes your preferences as to the marketing communications you would
    like to receive from us. We do not share your personal data with third parties for the purpose of enabling them
    to send marketing communications to you.
    <br><br>
    <span>We also collect, use and share Aggregated Data such as statistical or demographic data for any purpose.
            Aggregated Data could be derived from your personal data but is not considered personal data in law as this
            data will not directly or indirectly reveal your identity. For example, we may aggregate the personal data
            of the students using our products and services for the purpose of improving our products and services and
            sharing information about market trends with third parties. However, if we combine or connect Aggregated
            Data with your personal data so that it can directly or indirectly identify you, we treat the combined data
            as personal data which will be used in accordance with this privacy policy.</span>
    <br><br>
    <span>We do not collect any Special Categories of Personal Data about you (for example details about your race
            or ethnicity, religious or philosophical beliefs, sex life, sexual orientation, political opinions, trade
            union membership, information about your health, and genetic and biometric data).</span>
    <br><br>
    <span>We do not collect any information about criminal convictions and offences.</span>
    <br><br>

    <span class="center">IF YOU FAIL TO PROVIDE PERSONAL DATA</span>
    Where we need to collect personal data by law, or under the terms of a contract we have to provide products and/or
    services, and if you fail to provide that data when requested, we may not be able to perform the contract.
    <br><br><br>

    <span class="center">3. HOW IS YOUR PERSONAL DATA COLLECTED?</span>
    <span>We use different methods to collect data from and about you including through:</span>
    <br><br>
    <span class="bold">&bull; Direct interactions.</span>
    <span> As a student using our products and services, or as a visitor to our website, you may give us your
            Identity and Contact Data by filling in forms or by corresponding with us by post, phone, email or
            otherwise. This includes personal data you provide when you:</span>
    <br>
    <span>&#9702; apply for our products or services;</span>
    <br>
    <span>&#9702; use our products or services;</span>
    <br>
    <span>&#9702; requesting marketing information to be sent to you;</span>
    <br>
    <span>&#9702; give us feedback or contact us.</span>
    <br><br>
    <span class="bold">&bull; Automated technologies or interactions.</span>
    <span> As you interact with our website and use our services we will:</span>
    <br>
    <span>&#9702; automatically collect Technical Data about your equipment, browsing actions and patterns using
            cookies (in particular Google Analytics cookies) and other similar technologies. We may also receive
            Technical Data about you if you visit other websites employing our cookies. Please see our cookie policy for
            further details; and</span>
    <br>
    <span>&#9702; use analytics and machine learning to improve the user experience and the services that we
            provide.</span>
    <br><br><br>

    <span class="center">4. HOW WE USE YOUR PERSONAL DATA?</span>
    <span>We will only use your personal data when the law allows us to. Most commonly, we will use your personal
            data in the following circumstances:</span>
    <br><br>
    <span>&bull; Where we need to perform the contract we have entered into with you.</span>
    <br>
    <span>&bull; Where it is necessary for our Legitimate Interests (or those of a third party) and your interests
            and fundamental rights do not override those interests.</span>
    <br>
    <span>&bull; Where we need to Comply with a Legal Obligation.</span>
    <br><br>
    <span>There is more information in the Glossary below about the types of lawful basis that we will rely on to
            process your personal data.</span>
    <br><br>
    <span>Generally, we do not rely on consent as a legal basis for processing your personal data although we will
            get your consent before sending direct marketing communications to you via email or text message. You have
            the right to withdraw consent to marketing at any time by contacting us.</span>
    <br><br>

    <span class="center">PURPOSES FOR WHICH WE WILL USE YOUR PERSONAL DATA</span>
    We have set out below, in a table format, a description of all the ways we plan to use your personal data, and
    which of the legal bases we rely on to do so. We have also identified what our Legitimate Interests are where
    appropriate.
    <br><br>
    <span>Note that we may process your personal data for more than one lawful ground depending on the specific
            purpose for which we are using your data. Please contact us if you need details about the specific legal
            ground we are relying on to process your personal data where more than one ground has been set out in the
            table below.</span>
    <br><br>

    <table>
      <tr>
        <th class="bold cell">Purpose/Activity</th>
        <th class="bold cell">Data Types (as described above)</th>
        <th class="bold cell">Lawful basis for processing including basis of legitimate interest</th>
        <th class="bold cell">Retention Period</th>
      </tr>
      <tr>
        <td class="cell">
          1. To enable you to use this website and to apply for, and use, our products and services
          <br><br>
          This includes local storing of personal data (in your browser or other backup facility) to ensure
          that it is not lost when you take an online assessment
        </td>
        <td class="cell">
          (a) Identity
          <br>
          (b) Contact
          <br>
          (c) Profile
          <br>
          (d) Usage
          <br>
          (e) Marketing and Communications
        </td>
        <td class="cell">
          (a) Performance of a contract
          <br>
          (b) Necessary for our Legitimate Interests (to study how our customers use our products and
          services, to develop our products and services and to grow our business)
        </td>
        <td class="cell">
          Until you delete your account or until after 24 months after you last use your account
        </td>
      </tr>
      <tr>
        <td class="cell">
          2. To manage our relationship with you which will include:
          <br>
          (a) Notifying you about changes to our terms of use or privacy policy
          <br>
          (b) Asking you to give us feedback or contact us
          <br>
          (c) Sending email motivations/reminders to you about tasks which must be performed
          <br>
          (d) Sending notifications on the system (which are vital for our platform to be effective)
          <br>
          (e) For the Tutors and Career Counsellors to communicate with you.
        </td>
        <td class="cell">
          (a) Identity
          <br>
          (b) Contact
          <br>
          (c) Profile
          <br>
          (d) Marketing and Communications
        </td>
        <td class="cell">
          (a) Performance of a contract
          <br>
          (b) Necessary to Comply with a Legal Obligation
          <br>
          (c) Necessary for our Legitimate Interests (to keep our records updated and to study how our
          customers use our products and services)
        </td>
        <td class="cell">
          Until you delete your account or until after 24 months after you last use your account
        </td>
      </tr>
      <tr>
        <td class="cell">
          3. To administer and protect our business and this website (including troubleshooting, data
          analysis, testing, system maintenance, support, reporting and hosting of data)
        </td>
        <td class="cell">
          (a) Identity
          <br>
          (b) Contact
          <br>
          (c) Technical
        </td>
        <td class="cell">
          (a) Necessary for our Legitimate Interests (for running our business, provision of administration
          and IT services, network security, to prevent fraud and in the context of a business reorganisation
          or group restructuring exercise)
          <br>
          (b) Necessary to Comply with a Legal Obligation
        </td>
        <td class="cell">
          Until you delete your account or until after 24 months after you last use your account
        </td>
      </tr>
    </table>
    <br><br>

    <span class="center">CHANGE OF PURPOSE</span>
    We will only use your personal data for the purposes for which we collected it, unless we reasonably consider
    that we need to use it for another reason and that reason is compatible with the original purpose. If you wish
    to get an explanation as to how the processing for the new purpose is compatible with the original purpose,
    please contact us.
    <br><br>
    If we need to use your personal data for an unrelated purpose, we will notify you and we will explain the legal
    basis which allows us to do so.
    <br><br>
    Please note that we may process your personal data without your knowledge or consent, in compliance with the
    above rules, where this is required or permitted by law.
    <br><br><br>

    <span class="center">5. DISCLOSURES OF YOUR PERSONAL DATA</span>
    <span>The live online tutorials included within our services are one-to-one sessions meaning that when you join a
            tutorial session you will be the only participant in it along with the tutor.</span>
    <br><br>
    <span>We may share your personal data with 3rd parties that enable us to deliver our service to you. Below are
            examples of such parties:</span>
    <br><br>
    &bull; Sharpen App Ltd. which provides us with their “Sharpen App” to help us deliver our live online tutorials.
    When you register for our services, we will automatically create an account for you on the Sharpen system so
    that you can move seamlessly between our system and the Sharpen system (i.e. without needing to sign into
    multiple systems to access our live online tutorials). Sharpen also hosts the live recordings included within
    our services.
    <br><br>
    &bull; Amazon Web Services to host our website and the platform which delivers our online services.
    <br><br>
    &bull; Consultants that require access to your personal data so as to complete their task on behalf of the
    company.
    <br><br>
    <span>We may share your personal data with third parties to whom we may choose to sell, transfer or merge parts
            of our business or our assets. Alternatively, we may seek to acquire other businesses or merge with them. If
            a change happens to our business, then the new owners may use your personal data in the same way as set out
            in this privacy policy.</span>
    <br><br>
    <span>We require all third parties to respect the security of your personal data and to treat it in accordance
            with the law. We do not allow our third-party service providers to use your personal data for their own
            purposes and only permit them to process your personal data for specified purposes and in accordance with
            our instructions.</span>
    <br><br><br>

    <span class="center">6. INTERNATIONAL TRANSFERS</span>
    <span>If you are located in the European Economic Area (EEA) your personal data will be stored on servers in the
            EEA and we will not transfer your personal data outside the EEA. If you are located outside the EEA your
            personal data may be located in the EEA or in the country in which you are located.</span>
    <br><br>
    <span>We will ensure that any personal data which is transferred out of the EEA is protected to European Union
            standards.</span>
    <br><br><br>

    <span class="center">7. DATA SECURITY</span>
    <span>We have put in place appropriate security measures to prevent your personal data from being accidentally
            lost, used or accessed in an unauthorised way, altered or disclosed. In addition, we limit access to your
            personal data to those employees, agents, contractors and other third parties who have a business need to
            know. They will only process your personal data on our instructions and they are subject to a duty of
            confidentiality.</span>
    <br><br>
    <span>We have put in place procedures to deal with any suspected personal data breach and will notify you and any
            applicable regulator of a breach where we are legally required to do so.</span>
    <br><br><br>

    <span class="center">8. DATA RETENTION</span>
    <span class="center">HOW LONG WILL WE USE YOUR PERSONAL DATA?</span>
    <span>We will only retain your personal data for as long as reasonably necessary to fulfil the purposes we
            collected it for, including for the purposes of satisfying any legal, regulatory, tax, accounting or
            reporting requirements. We may retain your personal data for a longer period in the event of a complaint or
            if we reasonably believe there is a prospect of litigation in respect to our relationship with you.</span>
    <br><br>
    <span>To determine the appropriate retention period for personal data, we consider the amount, nature and
            sensitivity of the personal data, the potential risk of harm from unauthorised use or disclosure of your
            personal data, the purposes for which we process your personal data and whether we can achieve those
            purposes through other means, and the applicable legal, regulatory, tax, accounting or other
            requirements.</span>
    <br><br>
    <span>Details of how long we retain your personal data are set out in the table above.</span>
    <br><br>
    <span>In some circumstances you can ask us to delete your data. To make such a request please email us at
            <a href="mailto:contact@curriculum.com">contact@curriculum.com</a>.</span>
    <br><br>
    <span>In some circumstances we will anonymise your personal data (so that it can no longer be associated with
            you) for research or statistical purposes, in which case we may use this information indefinitely without
            further notice to you.</span>
    <br><br><br>

    <span class="center">9. YOUR LEGAL RIGHTS</span>
    <span>Under certain circumstances, you have rights under data protection laws in relation to your personal
            data:</span>
    <br><br>
    <span class="bold">&bull; Request access to your personal data</span>
    <span> (commonly known as a "data subject access request"). This enables you to receive a copy of the personal
            data we hold about you and to check that we are lawfully processing it.</span>
    <br><br>
    <span class="bold">&bull; Request correction of the personal data that we hold about you.</span>
    <span> This enables you to have any incomplete or inaccurate data we hold about you corrected, though we may
            need to verify the accuracy of the new data you provide to us.</span>
    <br><br>
    <span class="bold">&bull; Request erasure of your personal data.</span>
    <span> This enables you to ask us to delete or remove personal data where there is no good reason for us
            continuing to process it. You also have the right to ask us to delete or remove your personal data where you
            have successfully exercised your right to object to processing (see below), where we may have processed your
            information unlawfully or where we are required to erase your personal data to comply with local law. Note,
            however, that we may not always be able to comply with your request of erasure for specific legal reasons
            which will be notified to you, if applicable, at the time of your request.</span>
    <br><br>
    <span class="bold">&bull; Object to processing of your personal data</span>
    <span> where we are relying on a Legitimate Interest (or those of a third party) and there is something about
            your particular situation which makes you want to object to processing on this ground as you feel it impacts
            on your fundamental rights and freedoms. You also have the right to object where we are processing your
            personal data for direct marketing purposes. In some cases, we may demonstrate that we have compelling
            legitimate grounds to process your information which override your rights and freedoms.</span>
    <br><br>
    <span class="bold">&bull; Request restriction of processing of your personal data.</span>
    <span> This enables you to ask us to suspend the processing of your personal data in the following
            scenarios:</span>
    <br>
    <span>&bull; If you want us to establish the data's accuracy.</span>
    <br>
    <span>&bull; Where our use of the data is unlawful but you do not want us to erase it.</span>
    <br>
    <span>&bull; Where you need us to hold the data even if we no longer require it as you need it to establish,
            exercise or defend legal claims.</span>
    <br>
    <span>&bull; You have objected to our use of your data but we need to verify whether we have overriding
            legitimate grounds to use it.</span>
    <br><br>
    <span class="bold">&bull; Request the transfer of your personal data to you or to a third party.</span>
    <span> We will provide to you, or a third party you have chosen, your personal data in a structured, commonly
            used, machine-readable format. Note that this right only applies to automated information which you initially
            provided consent for us to use or where we used the information to perform a contract with you.</span>
    <br><br>
    <span class="bold">&bull; Withdraw consent</span>
    <span> at any time where we are relying on consent to process your personal data. However, this will not affect
            the lawfulness of any processing carried out before you withdraw your consent. If you withdraw your consent,
            we may not be able to provide certain products or services to you. We will advise you if this is the case at
            the time you withdraw your consent.</span>
    <br><br>
    <span>If you wish to exercise any of the rights set out above, please email us at
            <a href="mailto:contact@curriculum.com">contact@curriculum.com</a>.</span>
    <br><br>

    <span class="center">NO FEE USUALLY REQUIRED</span>
    <span>You will not have to pay a fee to access your personal data (or to exercise any of the other rights).
            However, we may charge a reasonable fee if your request is clearly unfounded, repetitive or excessive.
            Alternatively, we could refuse to comply with your request in these circumstances.</span>
    <br><br>

    <span class="center">WHAT WE MAY NEED FROM YOU</span>
    <span>We may need to request specific information from you to help us confirm your identity and ensure your
            right to access your personal data (or to exercise any of your other rights). This is a security measure to
            ensure that personal data is not disclosed to any person who has no right to receive it. We may also contact
            you to ask you for further information in relation to your request to speed up our response.</span>
    <br><br>

    <span class="center">TIME LIMIT TO RESPOND</span>
    <span>We try to respond to all legitimate requests within one month. Occasionally it could take us longer than a
            month if your request is particularly complex or you have made a number of requests. In this case, we will
            notify you and keep you updated.</span>
    <br><br><br>

    <span class="center">10. GLOSSARY</span>
    <span class="center">LAWFUL BASIS</span>
    <span class="bold">Comply with a Legal Obligation</span>
    <span> means processing your personal data where it is necessary for compliance with a legal obligation that we
            are subject to.</span>
    <br><br>
    <span class="bold">Legitimate Interest(s)</span>
    <span> means the interest of our business in conducting and managing our business to enable us to give you the
            best service and/or product and the best and most secure experience. We make sure we consider and balance
            any potential impact on you (both positive and negative) and your rights before we process your personal
            data for our legitimate interests. We do not use your personal data for activities where our interests are
            overridden by the impact on you (unless we have your consent or are otherwise required or permitted to by
            law). You can obtain further information about how we assess our legitimate interests against any potential
            impact on you in respect of specific activities by contacting us.</span>
    <br><br>
    <span class="bold">Performance of Contract</span>
    <span> means processing your data where it is necessary for the performance of the contract we have entered into
            with you.</span>
    <br><br><br>
  </div>
</div>
